// extracted by mini-css-extract-plugin
export default {"container":"SaveOrderButton_container__vMzct"};